import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  yardList: [],
  isYardLoading: true,
};

const yardSlice = createSlice({
  name: "yard",
  initialState,
  reducers: {
    setYardData(state, action) {
      state.yardList = action.payload;
      state.isYardLoading = false;
    },
    removeYardData(state, action) {
      state.yardList = [];
      state.isYardLoading = true;
    },
  },
});
export const { setYardData, removeYardData } = yardSlice.actions;
export default yardSlice.reducer;
